__turbopack_context__.v({
  "closeButton": "FreemiumSoClosePopup-module__ArOmxG__closeButton",
  "container": "FreemiumSoClosePopup-module__ArOmxG__container",
  "contentCarousel": "FreemiumSoClosePopup-module__ArOmxG__contentCarousel",
  "contentCarouselDots": "FreemiumSoClosePopup-module__ArOmxG__contentCarouselDots",
  "heading": "FreemiumSoClosePopup-module__ArOmxG__heading",
  "mainText": "FreemiumSoClosePopup-module__ArOmxG__mainText",
  "maybeLater": "FreemiumSoClosePopup-module__ArOmxG__maybeLater",
  "message": "FreemiumSoClosePopup-module__ArOmxG__message",
  "prizeImage": "FreemiumSoClosePopup-module__ArOmxG__prizeImage",
  "prizeImageCaption": "FreemiumSoClosePopup-module__ArOmxG__prizeImageCaption",
  "prizeImages": "FreemiumSoClosePopup-module__ArOmxG__prizeImages",
});
